import { TrendingUp } from 'lucide-react';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { EmptyState } from '@/components/ui/EmptyState';
import { formatBRL } from '@/lib/format';
import type { TopProduct } from '@/hooks/useMlOrders';

interface Props {
  products?: TopProduct[];
}

export function TopProducts({ products = [] }: Props) {
  return (
    <div className="card p-5 h-full">
      <SectionHeader title="Top 5 produtos" subtitle="Por faturamento (últimos 30 dias)" />
      {products.length === 0 ? (
        <EmptyState
          icon={TrendingUp}
          title="Sem dados de produtos"
          description="Nenhuma venda no período. Os dados sincronizam a cada 5 minutos."
        />
      ) : (
        <ul className="space-y-3 mt-2">
          {products.map((p, i) => (
            <li key={`${p.title}-${i}`} className="flex items-center gap-3">
              <span className="w-6 h-6 rounded-full bg-brand-100 text-brand-700 text-xs font-bold flex items-center justify-center shrink-0">
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-ink truncate">{p.title}</p>
                <p className="text-xs text-ink-muted">{p.qty} un.</p>
              </div>
              <span className="text-sm font-semibold text-ink shrink-0">{formatBRL(p.revenueCents)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
